var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 8,
    cy: 8,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8732 5.02486C10.8732 4.80395 10.6941 4.62486 10.4732 4.62486L6.87319 4.62486C6.65227 4.62486 6.47319 4.80395 6.47318 5.02486C6.47319 5.24578 6.65227 5.42486 6.87318 5.42486L10.0732 5.42486L10.0732 8.62486C10.0732 8.84578 10.2523 9.02486 10.4732 9.02486C10.6941 9.02486 10.8732 8.84578 10.8732 8.62486L10.8732 5.02486ZM5.80628 10.2575L10.756 5.3077L10.1903 4.74202L5.24059 9.69177L5.80628 10.2575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.bef7c8b8b4dad52748cafec6bbce64d5.svg";
export { ForwardRef as ReactComponent };